<div class="search-assets">
	<div class="top">
		<h3 class="title">{{ 'searchAssets.title' | translate }}</h3>
	</div>

	<div class="center">
		<tui-input
			[(ngModel)]="searchValue"
			tuiTextfieldIconLeft="@tui.search"
		>
			<label class="label">{{ 'searchAssets.inputLabel' | translate }}</label>
			<input
				class="input"
				tuiTextfieldLegacy
				type="text"
				tuiAutoFocus
			/>
		</tui-input>

		<app-table-search-assets
			[searchValue]="searchValue()"
			(onSelectAsset)="onSelectAsset($event)"
		/>
	</div>
</div>
